export default {
  impressions: [],
  impression: undefined,
};
